import React from "react"

function Error404() {
    console.log("Error404")
    return (
        <h1>Oops! Page not found!</h1>
    )
}

export default Error404